import type { AppGroupRevenueLifetimeStatsResults } from "../types";

export const fakeAppGroupRevenueLifetimeStatsResults: AppGroupRevenueLifetimeStatsResults = {
  lifetime_users: 1037311,
  lifetime_users_by_app: {
    "5e74e0157bda766ac5d8328c": 88,
    "5e8ce3da74cd236cc3f8a6cc": 2,
    "50d35b5c09dde7fa4c000001": 5944,
    "540a4e9d2dc4a338b7000002": 197,
    "57bf12dafbe76a35cf5bdf49": 18,
    "5785111ebf5cea5acb51051b": 40,
    "578ead46bf5cea16cda403f7": 1,
    "575879e5bf5cea05ede013bc": 143,
    "5877eba4bf5cea2310df934f": 1795,
    "59c3d6dcbf5cea3abf456600": 3,
    "5af333e3fbe76a0855a86dc6": 3,
    "5b3bc58ffbe76a3b50c565a1": 0,
    "5b450186bf5cea3b0abb2a41": 66,
    "5bdb41b2fbe76a521ca557b4": 71,
    "5bdb5462bf5cea0d4ea48d37": 15,
    "5bdb5cf6bf5cea3b34a48d32": 15,
    "5bdb5ec5bf5cea0dc5a48f1f": 2,
    "5bdb60e3bf5cea3b34a48d39": 40,
    "5bdb61c1bf5cea0d86a48e5b": 21,
    "5bff0765bf5cea3f95d4c0dd": 50,
    "5c1d2587fbe76a5a456aab41": 2,
    "5c23f13abf5cea5ed890e3fa": 24,
    "5c2419c7bf5cea5ea990e407": 2,
    "5cdbbeffbf5cea3ae693a751": 153,
    "5cfa9287bf5cea3e9b4a2e43": 167,
    "5d7278737bda765b9c1eee7c": 2467,
    "5d95116c74cd23381f529ac7": 41,
    "5dd2ea7b4b895c555c72af64": 66,
    "5dd853ae7bda7613d73fd5c6": 13,
    "5e2a02a04b895c63a436cb36": 6,
    "5e39b99a7bda764567a8df26": 65,
    "5e752d744b895c457a974f47": 112,
    "5e7cb49b74cd235ec7e6398e": 5,
    "5ea0b058e7bd692ab32e2a85": 7,
    "5ebbb8fc1968b24c808b3a98": 52,
    "5ecdfa981b47f2548fc12e57": 9,
    "51e075c63acc5eb00a000001": 214,
    "5ed5e057f578521bebd3c5ac": 411,
    "5ee105ed1b47f2547f50396f": 24,
    "5ee8f4f1f578521fcdaab27a": 9,
    "5eea8eaff5785244de70f0c6": 382,
    "5ef15e7e2eaf864c7ddc4cc2": 13,
    "5f03861ff5785213bd55b724": 116,
    "5f172560a76e0f456512614e": 2,
    "5f80c71e9fa5b656330e90de": 14,
    "5f91c58ea76e0f0469f0cd15": 2,
    "5fa40898438e84061ec6cc8a": 33,
    "5fc4b4859fa5b648ca0869a9": 11,
    "6008bc9ba76e0f249c7c9822": 67,
    "601a96d59fa5b671b2912014": 2,
    "6035a8bb9fa5b65af707e806": 1,
    "60366feca76e0f1ecbe5e94f": 4,
    "606b778a8bc32201ae3066db": 1,
    "606df2a07189c5592196049c": 614,
    "60906c390ab6ed3f000e143c": 2,
    "60cdc0023a531a540e9d9b72": 8,
    "60d37b5fad5610146d0dead0": 9,
    "60f10217d6e9b00f6ef19ea1": 0,
    "60f5d0b64fd6ad35a62337f0": 27,
    "61211d717e2a2447f6b35611": 2,
    "614106279d9bee7561ff6dcd": 86,
    "6155efbd310caa648cbd9dd3": 104,
    "615717a82defb25f6bd177b3": 147,
    "6192d80d9e31be044ed3016f": 1330,
    "61c2756bc7ce0445be03162b": 3,
    "62115f65f34fd908b9984b71": 60,
    "6228c0d4a7b6d13da9a98075": 5,
    "622a299430e74732fa49a261": 38,
    "62584e2ddc37d62ab941dfa0": 3,
    "6267f56e49123736db72f2ca": 9,
    "62712be18baeaa743f806f40": 13,
    "627418e76109130b038afda5": 5,
    "62758e62962dba145aa38874": 3,
    "62bdb88944e5ee75d3ec0de7": 1,
    "62f6c621582c6121c8b6a0b3": 1,
    "62fbdff930076a1067f5be91": 4,
    "63047ccc990d8817ef6a2baa": 2,
    "635c150cf08674005a8ab06a": 0,
    "636270511f331b0bff221180": 0,
    "63693b342459f206dbc31eb3": 0,
    "63754c01f1f84d695de530ee": 1,
    "63863b9aa47c977eb86eab93": 2,
    "639b218341650e762c23a22f": 5,
    "639b62b3f1f84d676d07da64": 0,
    "639b6342f1f84d676d07da69": 0,
    "63a3b9ac673cf8040812293a": 105,
    "63a4b378673cf8217112293a": 0,
    "63a4fe06a47c9750de4f7c51": 62,
    "63b606cbf1f84d2494ec0efe": 26,
    "63c7f2e88b20691195c770c8": 0,
    "63c855fbf1f84d7e81567624": 14,
    "63cf574ef1f84d0f47c9c874": 0,
    "63cf594b4c30751d72acc9a2": 0,
    "63cf59bf6a3945007d0049df": 0,
    "63e15de9ce4182489291b235": 3,
    "63feddbc22310d03e080fd49": 5,
    "64026468bbd89b303bca182a": 11,
    "6405f3e942ab1d74367256c2": 0,
    "64068482ce418252cabbb124": 1,
    "64068484ce418252cabbb129": 4,
    "6407884ac01e8104df8085c9": 0,
    "642d9a2a1468011c320d7bea": 22,
    "643676765881eb143b4958c4": 0,
  },
  lifetime_revenue: 1588914,
  lifetime_revenue_by_app: {
    "5e74e0157bda766ac5d8328c": 26,
    "5e8ce3da74cd236cc3f8a6cc": 12,
    "50d35b5c09dde7fa4c000001": 172657,
    "540a4e9d2dc4a338b7000002": 1937,
    "57bf12dafbe76a35cf5bdf49": 121,
    "5785111ebf5cea5acb51051b": 0,
    "578ead46bf5cea16cda403f7": 24,
    "575879e5bf5cea05ede013bc": 1324,
    "5877eba4bf5cea2310df934f": 58718,
    "59c3d6dcbf5cea3abf456600": 54,
    "5af333e3fbe76a0855a86dc6": 24,
    "5b3bc58ffbe76a3b50c565a1": 7,
    "5b450186bf5cea3b0abb2a41": 373,
    "5bdb41b2fbe76a521ca557b4": 344,
    "5bdb5462bf5cea0d4ea48d37": 108,
    "5bdb5cf6bf5cea3b34a48d32": 46,
    "5bdb5ec5bf5cea0dc5a48f1f": 6,
    "5bdb60e3bf5cea3b34a48d39": 144,
    "5bdb61c1bf5cea0d86a48e5b": 75,
    "5bff0765bf5cea3f95d4c0dd": 161,
    "5c1d2587fbe76a5a456aab41": 2,
    "5c23f13abf5cea5ed890e3fa": 101,
    "5c2419c7bf5cea5ea990e407": 14,
    "5cdbbeffbf5cea3ae693a751": 1155,
    "5cfa9287bf5cea3e9b4a2e43": 1482,
    "5d7278737bda765b9c1eee7c": 35345,
    "5d95116c74cd23381f529ac7": 440,
    "5dd2ea7b4b895c555c72af64": 197,
    "5dd853ae7bda7613d73fd5c6": 56,
    "5e2a02a04b895c63a436cb36": 10,
    "5e39b99a7bda764567a8df26": 750,
    "5e752d744b895c457a974f47": 885,
    "5e7cb49b74cd235ec7e6398e": 7,
    "5ea0b058e7bd692ab32e2a85": 46,
    "5ebbb8fc1968b24c808b3a98": 246,
    "5ecdfa981b47f2548fc12e57": 43,
    "51e075c63acc5eb00a000001": 278192,
    "5ed5e057f578521bebd3c5ac": 6043,
    "5ee105ed1b47f2547f50396f": 121,
    "5ee8f4f1f578521fcdaab27a": 14,
    "5eea8eaff5785244de70f0c6": 969393,
    "5ef15e7e2eaf864c7ddc4cc2": 67,
    "5f03861ff5785213bd55b724": 202,
    "5f172560a76e0f456512614e": 8,
    "5f80c71e9fa5b656330e90de": 275,
    "5f91c58ea76e0f0469f0cd15": 468,
    "5fa40898438e84061ec6cc8a": 446,
    "5fc4b4859fa5b648ca0869a9": 107,
    "6008bc9ba76e0f249c7c9822": 570,
    "601a96d59fa5b671b2912014": 11,
    "6035a8bb9fa5b65af707e806": 0,
    "60366feca76e0f1ecbe5e94f": 30,
    "606b778a8bc32201ae3066db": 6,
    "606df2a07189c5592196049c": 16758,
    "60906c390ab6ed3f000e143c": 8,
    "60cdc0023a531a540e9d9b72": 72,
    "60d37b5fad5610146d0dead0": 21,
    "60f10217d6e9b00f6ef19ea1": 4,
    "60f5d0b64fd6ad35a62337f0": 386,
    "61211d717e2a2447f6b35611": 330,
    "614106279d9bee7561ff6dcd": 14356,
    "6155efbd310caa648cbd9dd3": 464,
    "615717a82defb25f6bd177b3": 1136,
    "6192d80d9e31be044ed3016f": 18257,
    "61c2756bc7ce0445be03162b": 23,
    "62115f65f34fd908b9984b71": 1951,
    "6228c0d4a7b6d13da9a98075": 27,
    "622a299430e74732fa49a261": 108,
    "62584e2ddc37d62ab941dfa0": 0,
    "6267f56e49123736db72f2ca": 25,
    "62712be18baeaa743f806f40": 15,
    "627418e76109130b038afda5": 7,
    "62758e62962dba145aa38874": 9,
    "62bdb88944e5ee75d3ec0de7": 4,
    "62f6c621582c6121c8b6a0b3": 7,
    "62fbdff930076a1067f5be91": 7,
    "63047ccc990d8817ef6a2baa": 15,
    "635c150cf08674005a8ab06a": 0,
    "636270511f331b0bff221180": 0,
    "63693b342459f206dbc31eb3": 0,
    "63754c01f1f84d695de530ee": 11,
    "63863b9aa47c977eb86eab93": 87,
    "639b218341650e762c23a22f": 6,
    "639b62b3f1f84d676d07da64": 0,
    "639b6342f1f84d676d07da69": 0,
    "63a3b9ac673cf8040812293a": 977,
    "63a4b378673cf8217112293a": 0,
    "63a4fe06a47c9750de4f7c51": 283,
    "63b606cbf1f84d2494ec0efe": 395,
    "63c7f2e88b20691195c770c8": 0,
    "63c855fbf1f84d7e81567624": 44,
    "63cf574ef1f84d0f47c9c874": 0,
    "63cf594b4c30751d72acc9a2": 0,
    "63cf59bf6a3945007d0049df": 0,
    "63e15de9ce4182489291b235": 16,
    "63feddbc22310d03e080fd49": 16,
    "64026468bbd89b303bca182a": 42,
    "6405f3e942ab1d74367256c2": 0,
    "64068482ce418252cabbb124": 28,
    "64068484ce418252cabbb129": 95,
    "6407884ac01e8104df8085c9": 0,
    "642d9a2a1468011c320d7bea": 31,
    "643676765881eb143b4958c4": 0,
  },
  lifetime_revenue_by_country: {
    US: 892345,
    GB: 341290,
    CA: 187654,
    DE: 98211,
    FR: 42887,
    unknown: 26527,
    total: 1588914,
  },
};
